import { registerSwiperElements } from '~/shared/utils/register-swiper-elements';
import { enableMapSet } from 'immer';
import { environment } from '#environment';
import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

// global configuration
enableMapSet();

try {
  if (environment.production) {
    enableProdMode();
  }
} catch (e) {
  console.error('Error enabling production mode', e);
}

registerSwiperElements();
bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
